<mat-card aria-label="Tabs card" class="h-full">
  <mat-tab-group
    aria-label="Tabs group"
    class="h-full"
    [selectedIndex]="selectedTabIndex"
    (selectedTabChange)="onTabChange($event)">
    @for (tab of tabs; track tab.title) {
      <mat-tab aria-label="Tab {{ tab.title }}" [label]="tab.title" [disabled]="tab.disabled">
        <ng-template #tabContent />
      </mat-tab>
    }
  </mat-tab-group>
</mat-card>
